import { render, staticRenderFns } from "./logs_sistema.vue?vue&type=template&id=7a84c0f0&"
import script from "./logs_sistema.vue?vue&type=script&lang=js&"
export * from "./logs_sistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports